import { TextBase, TooltipBubble } from '@carboncopyco/ui';
import { MMMDoYYYY, dateUTCFormat } from '@carboncopyco/utils';

interface CreatedOnTooltipProps {
  dateTime: string;
}
export const CreatedOnTooltip = ({ dateTime }: CreatedOnTooltipProps) => {
  return (
    <TooltipBubble
      title={`Created on ${dateUTCFormat(dateTime)}`}
      placement="top"
    >
      <TextBase
        color="text-ds-natural-300"
        label={MMMDoYYYY(dateTime)}
      />
    </TooltipBubble>
  );
};
